RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const CompanyProfile = apps.CompanyProfile = window.createMarionetteApp();
    CompanyProfile.name = 'CompanyProfile';
});
